var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 35 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3723 7.9482V0.500732H22.1246L30.7559 6.5425C31.7934 7.36287 32.5531 8.42686 33.1094 9.59501H18.0189C17.1109 9.59501 16.3723 8.8562 16.3723 7.9482Z",
    fill: "#0C2344"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6773 21.5007C28.3324 21.5007 27.2421 20.4105 27.2421 19.0655C27.2421 17.7206 28.3324 16.6303 29.6773 16.6303C31.0223 16.6303 32.1125 17.7206 32.1125 19.0655C32.1125 20.4105 31.0223 21.5007 29.6773 21.5007Z",
    fill: "#0C2344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31291 21.5007C4.96802 21.5007 3.87778 20.4104 3.87778 19.0655C3.87778 17.7206 4.96802 16.6304 6.31291 16.6304C7.6578 16.6304 8.74805 17.7206 8.74805 19.0655C8.74805 20.4104 7.6578 21.5007 6.31291 21.5007Z",
    fill: "#0C2344"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.974 7.9482V0.500732H15.3194V7.9482C15.3194 9.43666 16.5304 10.648 18.0189 10.648H33.5502C34.8153 14.1398 34.5594 18.1653 34.427 19.4945H33.1364C33.1537 19.3536 33.1655 19.2111 33.1655 19.0656C33.1655 17.1422 31.6007 15.5771 29.6775 15.5771C27.754 15.5771 26.1892 17.1422 26.1892 19.0656C26.1892 19.2111 26.201 19.3536 26.2184 19.4945H9.77184C9.78922 19.3536 9.80097 19.2111 9.80097 19.0656C9.80097 17.1422 8.23616 15.5771 6.313 15.5771C4.54045 15.5771 3.07559 16.9077 2.85645 18.6218H0.117981V10.648H9.27449C10.763 10.648 11.974 9.43666 11.974 7.9482Z",
    fill: "#0C2344"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9209 0.500732V7.9482C10.9209 8.8562 10.1823 9.59501 9.27435 9.59501H0.117841V0.500732H10.9209Z",
    fill: "#0C2344"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.7d13b80525f53d1822ff204123d0c10a.svg";
export { ForwardRef as ReactComponent };